import React from 'react';
import { Box } from '@mui/material';

const FaanaLogo = ({ size = 80 }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Faana Logo */}
      <Box
        component="img"
        src="/faana_logo.png"
        alt="Faana"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default FaanaLogo;